s<div class="error-wrapper">
  <div class="error">
    <div class="logo__error">
      <img src="assets/images/logo.svg">
    </div>

    <div class="error__inner">
      <div class="icon-wrapper">
        <i class="fal fa-exclamation-circle" style="font-size: 65px;"></i>
      </div>
      <h1>Error 401 - Unauthorized</h1>
      <p>You are unauthorized to view this resource <br />
        Please contact system administrator</p>
      <!-- <p *ngIf="getAccess()"><a (click)="toHome()" class="error-btn">Go to Home</a></p>
      <p *ngIf="!getAccess()"><a (click)="onLogout()" class="error-btn">Logout</a></p> -->
      <p><a (click)="onLogout()" class="error-btn">Logout</a></p>
    </div>
  </div>
</div>
